export const getUiIdClassName = (hash: string) => `ui-id-${hash}`;

export const getUiIdSelector = (className: string) => `*:has(>.${className})`;
